// extracted by mini-css-extract-plugin
module.exports = {"content":"Customization_content__1AMUI","submitBtn":"Customization_submitBtn__1T_jy"};